var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingSidebarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75016 11.0827H0.583496V10.4993C0.583496 9.4121 1.32711 8.49854 2.3335 8.23952M3.50016 6.31644C2.82047 6.0762 2.3335 5.42798 2.3335 4.66602C2.3335 3.90406 2.82047 3.25584 3.50016 3.0156M12.2502 11.0827H13.4168V10.4993C13.4168 9.4121 12.6732 8.49854 11.6668 8.23952M10.5002 3.0156C11.1799 3.25584 11.6668 3.90406 11.6668 4.66602C11.6668 5.42798 11.1799 6.0762 10.5002 6.31644M5.8335 8.16602H8.16683C9.45549 8.16602 10.5002 9.21068 10.5002 10.4993V11.0827H3.50016V10.4993C3.50016 9.21068 4.54483 8.16602 5.8335 8.16602ZM8.75016 4.66602C8.75016 5.63251 7.96666 6.41602 7.00016 6.41602C6.03366 6.41602 5.25016 5.63251 5.25016 4.66602C5.25016 3.69952 6.03366 2.91602 7.00016 2.91602C7.96666 2.91602 8.75016 3.69952 8.75016 4.66602Z",
    stroke: "#6C737F",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#6C737F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingSidebarIcon);
export default __webpack_public_path__ + "static/media/setting-sidebar-icon.ebe2bd5e3f2debf348a4772c0acf1221.svg";
export { ForwardRef as ReactComponent };